import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useContext,
  useState,
} from "react";

import { notImplementedError } from "utils/common";

import FeatureLimitDialog from "components/FeatureLimitDialog";
import { EFeatureLimitItemsType } from "components/FeatureLimitDialog/constants";

const FeatureLimitContext = React.createContext({
  show: notImplementedError,
  hide: notImplementedError,
  setItems: notImplementedError as Dispatch<
    SetStateAction<EFeatureLimitItemsType>
  >,
  setOnClose: notImplementedError as Dispatch<SetStateAction<() => void>>,
});

interface IuseFeatureLimitArgs {
  items: EFeatureLimitItemsType;
  onClose?: () => void;
}

export interface IFeatureLimitContextProvider {
  children: React.ReactNode;
}

export const FeatureLimitContextProvider = ({
  children,
}: IFeatureLimitContextProvider) => {
  const [isOpen, setIsOpen] = useState(false);
  const [items, setItems] = useState<EFeatureLimitItemsType>(
    EFeatureLimitItemsType.DEALS
  );
  const [onClose, setOnClose] = useState(() => () => {});

  const show = useCallback(() => {
    setIsOpen(true);
  }, []);

  const hide = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <FeatureLimitContext.Provider
      value={{
        show,
        hide,
        setItems,
        setOnClose,
      }}
    >
      {children}
      <FeatureLimitDialog isOpen={isOpen} onClose={onClose} items={items} />
    </FeatureLimitContext.Provider>
  );
};

export const useFeatureLimitDialog = () => {
  const {
    show: showDialog,
    hide,
    setItems,
    setOnClose,
  } = useContext(FeatureLimitContext);

  const show = useCallback(
    ({
      items = EFeatureLimitItemsType.DEALS,
      onClose = hide,
    }: IuseFeatureLimitArgs) => {
      setItems(items);
      setOnClose(() => onClose);
      showDialog();
    },
    [hide, setItems, setOnClose, showDialog]
  );

  return { show, hide };
};
